import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/login/index.vue'),
      meta: {
        title: '登录',
        needLogin: false
      }
    },
    {
      path: '/login2',
      name: 'Login2',
      component: () => import('@/pages/login/login2.vue'),
      meta: {
        title: '登录',
        needLogin: false
      }
    },
    {
      path: '/wxLogin',
      name: 'wxLogin',
      component: () => import('@/pages/login/wxLogin.vue'),
      meta: {
        title: '登录',
        needLogin: false
      }
    },
    {
      path: '/openid',
      name: 'login-openid',
      component: () => import('@/pages/login/openid.vue'),
      meta: {
        title: 'id',
        needLogin: false
      }
    },
    {
      path: '/price',
      name: 'price',
      component: () => import('@/pages/login/price.vue'),
      meta: {
        title: '产品价格',
        needLogin: false
      }
    },
    {
      path: '/logining',
      name: 'logining',
      component: () => import('@/pages/login/ing.vue'),
      meta: {
        title: '登陆中',
        needLogin: true
      }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/pages/home/index.vue'),
      meta: {
        title: '首页',
        needLogin: true
      }
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import('@/pages/cart/index.vue'),
      meta: {
        title: '购物车',
        needLogin: true
      }
    },
    {
      path: '/cart/sub/:id(\\d+)',
      name: 'cart-sub',
      component: () => import('@/pages/cart/sub.vue'),
      meta: {
        title: '收货人信息确认',
        needLogin: true
      }
    },
    {
      path: '/my/address/:type(\\d+)',
      name: 'my-address',
      component: () => import('@/pages/my/address/index.vue'),
      meta: {
        title: '收货地址管理',
        needLogin: true
      }
    },
    {
      path: '/my/address/add',
      name: 'my-address-add',
      component: () => import('@/pages/my/address/add.vue'),
      meta: {
        title: '新增地址',
        needLogin: true
      }
    },
    {
      path: '/my/address/edit/:id(\\d+)',
      name: 'my-address-edit',
      component: () => import('@/pages/my/address/edit.vue'),
      meta: {
        title: '修改地址',
        needLogin: true
      }
    },
    {
      path: '/order',
      name: 'order',
      component: () => import('@/pages/order/index.vue'),
      meta: {
        title: '订单',
        needLogin: true
      }
    },
    {
      path: '/order/detail/:id(\\d+)/:type(\\d+)',
      name: 'order-detail',
      component: () => import('@/pages/order/detail.vue'),
      meta: {
        title: '订单详情',
        needLogin: true
      }
    },
    {
      path: '/my',
      name: 'my',
      component: () => import('@/pages/my/index.vue'),
      meta: {
        title: '我的',
        needLogin: true
      }
    },
    {
      path: '/my/pwd',
      name: 'my-pwd',
      component: () => import('@/pages/my/pwd.vue'),
      meta: {
        title: '修改密码',
        needLogin: true
      }
    },
    {
      path: '/my/certification',
      name: 'my-certification',
      component: () => import('@/pages/my/certification.vue'),
      meta: {
        title: '企业认证',
        needLogin: true
      }
    },
    {
      path: '/my/account',
      name: 'my-account',
      component: () => import('@/pages/my/account/index.vue'),
      meta: {
        title: '收支明细',
        needLogin: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js